import React, {useState} from 'react';
import './Search.scss';

const Search = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            const domain = process.env.REACT_APP_URL;
            const searchTermEncoded = encodeURIComponent(searchTerm);
            window.location.href = `${domain}/index.php?route=product/search&search=${searchTermEncoded}&description=true`
        }
    };

    return (
        <div className="content-search">
            <input
                className="search"
                type="search"
                placeholder="Search for Album or Artist"
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                onKeyDown={handleKeyDown}
            />
        </div>
    );
}

export default Search;
